import { render, staticRenderFns } from "./RelatoriosHomeView.vue?vue&type=template&id=c4ae34ee&scoped=true"
import script from "./RelatoriosHomeView.vue?vue&type=script&lang=js"
export * from "./RelatoriosHomeView.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosHomeView.vue?vue&type=style&index=0&id=c4ae34ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ae34ee",
  null
  
)

export default component.exports